<template>
  <Object3D :name="name">
    <mesh
      :position="position"
      :scale="scale"
      :rotation="rotation"
      :onRaycaster="Show"
    >
      <geometry type="Plane" :args="args"></geometry>
      <material type="MeshBasic" :options="matOpts">
        <canvas-text
          :cirColor="cirColor"
          :dotColor="dotColor"
          :show="false"
        ></canvas-text>
        <canvas-texture></canvas-texture>
      </material>
    </mesh>
    <mesh
      v-if="tipsShow"
      :position="position"
      :scale="scale"
      :rotation="rotation"
    >
      <geometry type="Plane" :args="args"></geometry>
      <material type="MeshBasic" :options="matOpts">
        <canvas-text
          :show="true"
          :cirColor="cirColor"
          :dotColor="dotColor"
          :textBgColor="textBgColor"
          :title="title"
          :describe="describe"
          :textcolor="font.color"
          :fontType="font.fontType"
        ></canvas-text>
        <canvas-texture></canvas-texture>
      </material>
    </mesh>
  </Object3D>
</template>

<script>
import Object3D from "../vue_three_js/components/Object3D";
import * as THREE from "three";
export default {
  name: "InformationTips",
  mixins: [Object3D],
  props: {
    name:{
      type: String,
      default() {
        return "";
      },
    },
    position: {
      type: Object,
      default() {
        return { x: 0, y: 0, z: -50 };
      },
    },
    rotation: {
      type: Object,
      default() {
        return { x: 0, y: 0, z: 0 };
      },
    },
    scale:{
      type:Number,
      default(){
        return 1
      }
    },
    title: {
      // 标题
      type: String,
      default() {
        return "标题";
      },
    },
    describe: {
      // 这是内容
      type: String,
      default() {
        return "这是内容";
      },
    },

    textBgColor:{
      // 文本背景色
        type: String,
        default() {
          return 'rgba(0, 0, 0,0.5)';
        },
    },
    cirColor: {
      // 圆形颜色
      type: String,
      default() {
        return "rgba(0, 0, 0,0.5)";
      },
    },
    dotColor: {
      // 圆点和长条颜色
      type: String,
      default() {
        return "rgba(255, 255, 255,0.9)";
      },
    },
    font:{
      // 微软雅黑
      type: Object,
      default() {
        return {
          fontType:'微软雅黑',
          color:'#FFF'
        };
      },
    }
  },
  data() {
    return {
      tipsShow: false,
      matOpts: {
        color: 0xffffff,
        side: THREE.DoubleSide,
        // blending: THREE.AdditiveBlending,
        opacity: 1,
        // depthWrite: false,
        transparent: true,
      },
      args: [10, 10],
    };
  },
  methods: {
    Show() {
      this.tipsShow = !this.tipsShow;
    },
  },
  created(){
  },
  beforeDestroy() {
    this.Show = null;
  },
};
</script>

<style>
</style>
